<div class="modal-header">
    <h3 class="modal-title">SQL Choices Override Guide</h3>
</div>
<div class="modal-body">
    <p>
        This feature allows for advanced users to construct custom user group definitions using a SQL query.
        The query should be formatted in order to complete the following insert statement:
    </p>

    <p>
        INSERT UserGroupMemberPersist (UserGroupID, PRCo, Employee, EmployeeName)<br /><br />

        The UserGroupID can be found in the URL of the current page.  In the example below, the UserGroupID would be 1027.<br /><br />
        https://myportal.keystyledata.com/Admin/ManageEmployeeGroups#/UserGroupID/<strong>1027</strong> <br /><br />

        As an example query to show all active employees in PR Company 3:
    </p>

    <p>SELECT 1027, PRCo, Employee, FirstName + ' ' + LastName<br />from kPREH<br />where PRCo = 3 and ActiveYN = 'Y'</p>

    <p>Viewpoint Views are not supported.</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>
